import { FormattedMessage } from 'react-intl';
import React from 'react';
import Alert from './UI/Alert';
import mailSentLogo from '../assets/img/undraw_Mail_sent.svg';

function MessageSent({
  response,
}: {
  response: { message: string; status: number } | null;
}) {
  if (response) {
    if (response?.status === 200) {
      return (
        <Alert>
          <img src={mailSentLogo} alt="" width={100} />
          <br />
          {' '}
          <br />
          <FormattedMessage id="contact.message-sent" />
          <br />
          {response?.message}
        </Alert>
      );
    }
    return (
      <Alert>
        <FormattedMessage id="contact.error-while-sending" />
        <br />
        <br />
        <FormattedMessage id="contact.error-use-linkedin" />
      </Alert>
    );
  }
  return null;
}

export default MessageSent;
